export default "__VITE_ASSET__TnCl7qme__"